import { render, staticRenderFns } from "./BdStatus.vue?vue&type=template&id=d5849cd8&"
import script from "./BdStatus.vue?vue&type=script&lang=js&"
export * from "./BdStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports